import { AxiosInstance } from 'axios';
import { createAxios, TokenGenerator } from './http';

class HttpClient {
  private axiosInstance: AxiosInstance | null = null;
  private tokenGenerator: TokenGenerator = () => Promise.reject();

  initialize(baseURL: string, tokenGenerator: TokenGenerator) {
    this.axiosInstance = createAxios(
      {
        baseURL,
      },
      tokenGenerator,
    );
    this.tokenGenerator = tokenGenerator;
    return this.axiosInstance;
  }

  get instance() {
    if (!this.axiosInstance) {
      throw new Error(`HttpClient has not been initialized`);
    }
    return this.axiosInstance;
  }

  get getAccessToken() {
    return this.tokenGenerator;
  }
}

const httpClient = new HttpClient();

export default httpClient;
